import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import { appendUrlParam } from "@/utils/url";
export default {
  name: "SchematicImg",
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    max: {
      type: Number,
      default: 1
    }
  },
  watch: {
    imgUrl: function imgUrl() {
      this.imgArr.push(this.imgUrl);
      this.$emit('input', this.imgArr);
    },
    value: {
      handler: function handler(nVal) {
        this.imgArr = JSON.parse(JSON.stringify(nVal));
      },
      immediate: true,
      deep: true
    }
  },
  data: function data() {
    return {
      imgArr: [],
      imgUrl: '',
      previewDialogVisible: false
    };
  },
  methods: {
    removeImg: function removeImg(index) {
      this.imgArr.splice(index, 1);
      this.$emit('input', this.imgArr);
    },
    previewImage: function previewImage(index) {
      var _this$$refs;
      (_this$$refs = this.$refs["image_".concat(index)]) === null || _this$$refs === void 0 || (_this$$refs = _this$$refs[0]) === null || _this$$refs === void 0 || _this$$refs.handleClick();
    }
  }
};